export default "__VITE_ASSET__3b735f79__"